<template>
  <div>
    <b-overlay :show="loading">
      <div
        v-if="showSaveOption"
        class="save-card-option d-flex justify-content-between align-items-center"
      >
        <div class="d-flex align-items-center">
          <feather-icon
            icon="InfoIcon"
            class="mr-50"
          />
          <span>¿Desea guardar su tarjeta de manera segura para
            agilizar futuros pagos?</span>
        </div>
        <b-form-checkbox
          v-model="saveNewCard"
          switch
          class="custom-control-primary"
          @input="saveCard"
        />
      </div>

      <b-form-radio-group
        v-if="savedCards.length > 0"
        v-model="selectedCard"
        class="saved-cards-list mt-2"
      >
        <div
          v-for="card in savedCards"
          :key="card.id"
          class="saved-card-item d-flex align-items-center cursor-pointer"
          :class="{
            'saved-card-item--selected': selectedCard === card.id,
          }"
          @click="selectCard(card)"
        >
          <b-form-radio
            :value="card.id"
            class="mr-1"
          />
          <b-avatar
            square
            size="34"
            :variant="getCardBrand(card.brand).variant"
            class="mr-2 card-brand-tile"
          >
            <feather-icon
              :icon="getCardBrand(card.brand).icon"
              size="16"
            />
          </b-avatar>
          <div class="flex-grow-1">
            <h6 class="mb-0 saved-card-name">
              {{ card.brand }}: {{ card.number }}
            </h6>
            <small
              class="text-muted"
            >Expira: {{ card.expiration }}</small>
          </div>
          <b-button
            variant="flat-danger"
            size="sm"
            class="btn-icon"
            @click.stop="confirmDelete(card)"
          >
            <feather-icon
              icon="TrashIcon"
              size="16"
            />
          </b-button>
        </div>
      </b-form-radio-group>
    </b-overlay>
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BOverlay,
} from "bootstrap-vue"

export default {
  components: {
    BOverlay,
    BAvatar,
    BButton,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
  },
  props: {
    idcontrato: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      showSaveOption: true,
      saveNewCard: false,
      savedCards: [],
      selectedCard: null,
      loading: false,
    }
  },
  created() {
    this.fetchSavedCards()
  },
  methods: {
    async fetchSavedCards() {
      try {
        this.loading = true
        const response = await this.$http.get("/card", {
          params: {
            contract_id: this.idcontrato,
            user_id: this.userData.id,
          },
        })
        this.savedCards = response.data.data ?? []
      } catch (error) {
        console.error("Error fetching saved cards:", error)
      } finally {
        this.loading = false
      }
    },
    saveCard() {
      this.$emit("saveCard", this.saveNewCard)
    },
    selectCard(card) {
      this.selectedCard = card.id
      this.$emit("cardSelected", card)
    },
    confirmDelete(card) {
      this.$swal({
        title: "¿Está seguro?",
        text: "¿Desea eliminar esta tarjeta? Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteCard(card)
        }
      })
    },
    async deleteCard(card) {
      try {
        this.loading = true
        await this.$http.delete(`/card/${card.id}`)
        this.loading = false
        await this.fetchSavedCards()
      } catch (error) {
        this.loading = false
        console.error("Error deleting card:", error)
      }
    },
    getCardBrand(brand) {
      const brands = {
        visa: { icon: "CreditCardIcon", variant: "primary" },
        mastercard: { icon: "CreditCardIcon", variant: "danger" },
        amex: { icon: "CreditCardIcon", variant: "success" },
        default: { icon: "CreditCardIcon", variant: "secondary" },
      }

      return brands[brand.toLowerCase()] || brands.default
    },
  },
}
</script>

<style lang="scss" scoped>
.save-card-option {
    background-color: var(--tm-surface-muted);
    border-radius: var(--tm-radius-sm);
    padding: 0.875rem;
}

.card-brand-tile {
    border-radius: var(--tm-radius-sm) !important;
}

.saved-cards-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.saved-card-item {
    border: 1px solid var(--tm-border);
    border-radius: var(--tm-radius);
    padding: 0.75rem 0.875rem;
}

.saved-card-item--selected {
    border-width: 1.5px;
    border-color: var(--tm-primary);
    background-color: rgba(var(--tm-primary-rgb), var(--tm-tint-soft));
}

.saved-card-name {
    font-size: 0.84375rem;
    font-weight: 600;
}
</style>
